const siteConfig = {
  brandName: "irtradeco",
  displayName: "IRTRADECO",
  shortName: "IRTRADECO",
  logo: {
    type: "image",
    src: "/head/irtradeco-wordmark.svg",
    alt: "irtradeco",
  },
  description:
    "Independent clothing and objects shaped by colour, function and unexpected construction.",
  tagline: "Colour in motion.",
  announcement: "COMPLIMENTARY DELIVERY ON ORDERS OVER $250",
  legalEntity: {
    name: "SHOES SELLER LIMITED",
    address:
      "FLAT/RM A, 9/F SILVERCORD INTERNATIONAL TOWER, 707-713 NATHAN ROAD, MONGKOK, KOWLOON, HONG KONG",
  },
  contact: {
    email: "clear@irtradeco.cc",
  },
  currency: { code: "USD", locale: "en-US", symbol: "$" },
  commerce: {
    freeShippingThreshold: 250,
    standardShipping: 12,
    returnsWindowDays: 21,
  },
  storage: {
    cart: "irtradeco-cart",
    wishlist: "irtradeco-wishlist",
  },
  navigation: {
    shop: [
      { label: "Latest pieces", query: "new" },
      { label: "Outerwear", category: "Outerwear" },
      { label: "Trousers", category: "Trousers" },
      { label: "Dresses", category: "Dresses" },
      { label: "Knitwear", category: "Knitwear" },
      { label: "Skirts", category: "Skirts" },
      { label: "Accessories", category: "Accessories" },
      { label: "Complete catalogue" },
    ],
  },
  moreLinks: [
    { label: "About", route: "/about" },
    { label: "Contact", route: "/contact" },
    { label: "Delivery", route: "/shipping" },
    { label: "Returns", route: "/returns" },
    { label: "Size guide", route: "/size-guide" },
    { label: "Garment care", route: "/care-guide" },
    { label: "Payment & security", route: "/payment-security" },
    { label: "FAQs", route: "/faqs" },
    { label: "Cookie policy", route: "/cookies" },
    { label: "Privacy policy", route: "/privacy" },
    { label: "Terms & conditions", route: "/terms" },
    { label: "Accessibility", route: "/accessibility" },
  ],
  social: [],
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
    minimumFractionDigits: 0,
  }).format(Number(value));

export default siteConfig;
